<app-credit-structure-card
  [size]="size"
  [index]="index"
  [structure]="structure"
  [selectMultiple]="selectMultiple"
  [canCheck]="canCheck"
  [canOptimize]="canOptimize"
  [imageURI]="imageURI"
  [structureYear]="structureYear"
  [structureProgram]="structureProgram"
  [canCreateSubmission]="canCreateSubmission$ | async"
  (structureClick)="structureClick.emit()"
  (structureCheckChange)="structureCheckChange.emit()"
  (optimizeClick)="optimizeClick.emit()"
  (createSubmissionClick)="onCreateSubmissionClick()"
></app-credit-structure-card>
